import { Button, IconButton } from '@material-ui/core'
import { GRAY_COLORS, PRIMARY_COLORS } from 'asterX-UI'
import { CloseIcon } from 'asterX-UI/Icons'
import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import PageContainerDesktop from 'components/PageContainer/layout/PageContainer.desktop'

const useStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16,
    marginBottom: 20
  },
  heading: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px',
    marginRight: 'auto'
  },
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  blockHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginBottom: 20
  },
  headerName: {
    fontSize: 14,
    fontWeight: 600
  },
  headerCounter: {
    borderRadius: '100%',
    backgroundColor: PRIMARY_COLORS['50'],
    fontSize: 12,
    color: PRIMARY_COLORS['700'],
    width: 24,
    height: 24,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  blockWrap: {
    display: 'flex',
    flexWrap: 'wrap',
    columnGap: 32,
    rowGap: 18,
    marginBottom: 32
  },
  wrapEl: {
    padding: '2px 8px',
    backgroundColor: PRIMARY_COLORS['50'],
    borderRadius: 16,
    fontSize: 12,
    fontWeight: 500
  }
}))
const OptionsModal = ({ onClose, car }) => {
  const classes = useStyles()
  return (
    <PageContainerDesktop
      customHeader={
        <div className={classes.header}>
          <div className={classes.heading}>Опции</div>
          <IconButton
            style={{
              color: GRAY_COLORS[400]
            }}
            onClick={onClose}
            size={'medium'}
          >
            <CloseIcon />
          </IconButton>
        </div>
      }
    >
      <div className={classes.container}>
        <div>
          <div className={classes.blockHeader}>
            <div className={classes.headerName}>Комфорт</div>
            <div className={classes.headerCounter}>3</div>
          </div>
          <div className={classes.blockWrap}>
            <div className={classes.wrapEl}>Активная подвеска</div>
            <div className={classes.wrapEl}>Кондиционер</div>
            <div className={classes.wrapEl}>Круиз-контроль</div>
          </div>
        </div>
        <div>
          <div className={classes.blockHeader}>
            <div className={classes.headerName}>Безопасность</div>
            <div className={classes.headerCounter}></div>
          </div>
          <div className={classes.blockWrap}>
            <div className={classes.wrapEl}>Активная подвеска</div>
            <div className={classes.wrapEl}>Кондиционер</div>
          </div>
        </div>
        <div>
          <div className={classes.blockHeader}>
            <div className={classes.headerName}>Мультимедиа</div>
            <div className={classes.headerCounter}>1</div>
          </div>
          <div className={classes.blockWrap}>
            <div className={classes.wrapEl}>Активная подвеска</div>
          </div>
        </div>
      </div>
      <Button
        variant={'contained'}
        color={'primary'}
        fullWidth
        size={'small'}
        onClick={onClose}
      >
        Закрыть
      </Button>
    </PageContainerDesktop>
  )
}

export default OptionsModal
